import { montserratMedium, montserratNormal, montserratSemibold } from '@/assets/fonts/montserrat'
import React, { useEffect, useState } from 'react'
import image3 from "@/assets/bookeeping_page/image3.svg"
import image4 from "@/assets/bookeeping_page/image4.svg"
import image5 from "@/assets/bookeeping_page/image5.svg"
import image6 from "@/assets/bookeeping_page/image6.svg"
import image6_en from "@/assets/bookeeping_page/image6_en.svg"
import image7 from "@/assets/bookeeping_page/image7.png"
import Image from 'next/image'
import { useTranslation } from 'react-i18next';

export default function Benefit({
  language
}) {
  const { t } = useTranslation();
  const [lang, setLang] = useState("")

  useEffect(() => {
    setLang(language)
  }, [language])

  return (
    <div className='overflow-hidden bg-gray-cool-50 relative px-4 py-16 lg:px-8 flex flex-col w-full h-full'>
      <div className='flex max-w-[1280px] lg:mx-auto lg:container flex-col w-full h-full'>
        <div className='w-full pb-16 h-full flex flex-col justify-center items-center'>
          <p className={`${montserratSemibold.className} text-blue-primary-500 text-sm`}>{t("pricing_detail_list_title")}</p>
          <div className={`${montserratSemibold.className} leading-[44px] text-[36px] text-gray-cool-700 py-3 text-center`}>{t("what_you'll_get")}</div>
          <p className={`${montserratNormal.className} text-gray-cool-500 text-[20px] w-full md:w-[50%] text-center`}>{t("bookeeping_desc_benefit")}</p>
        </div>
        <div className="w-full h-full flex justify-center items-center">
          <div className='grid md:gap-y-6 gap-y-6 w-full md:w-[90%] grid-flow-row grid-cols-1 md:grid-cols-2 md:grid-flow-col md:gap-6 lg:grid-cols-3'>
            <div className='md:col-start-1 h-full max-w-none xl:max-w-[820px] bg-base-white flex flex-col md:flex-row w-full relative pt-6 pl-6 pr-6 overflow-hidden justify-between rounded-md border-[1px] border-gray-cool-200 md:col-span-2'>
              <div className='flex w-full pr-9 flex-col'>
                <p className={`${montserratSemibold.className} text-[20px] text-gray-cool-700`}>{t("bookeeping_profit_and_lose")}</p>
                <p className={`${montserratNormal.className} w-full pt-2 text-base text-gray-cool-500`}>{t("bookeeping_profit_and_lose_desc")}</p>
              </div>
              <div className="w-full md:pt-0 pt-9 right-0 relative bottom-0">
                <Image src={image3} className="relative " />
              </div>
            </div>
            <div className='rounded-lg md:col-start-1 lg:col-start-3 h-full items-center w-fit border-[1px] pb-6 pl-6 pr-6 flex flex-col overflow-hidden border-gray-cool-200 bg-base-white '>
              <div className="w-auto relative overflow-hidden object-contain bg-contain">
                <Image src={image4} />
              </div>
              <div className={`grid grid-cols-1 pt-[36px]`}>
                <p className={`${montserratMedium.className} text-gray-cool-700 text-[20px] pb-2`}>{t("bookeeping_cash_flow")}</p>
                <p className={`${montserratNormal.className} text-gray-cool-500 text-base`}>{t("bookeeping_cash_flow_desc")}</p>
              </div>
            </div>
            <div className='grid grid-cols-1 rounded-lg md:col-start-2 lg:col-start-1 h-full items-center w-fit border-[1px] pb-6 pl-6 pr-6 overflow-hidden max-w-[380px] border-gray-cool-200 bg-base-white '>
              <div className="md:w-full max-w-[312px] lg:w-[20rem] relative overflow-hidden object-contain bg-contain mr-6">
                <Image src={image5} />
              </div>
              <div className={`flex flex-col justify-end h-fit pt-9`}>
                <p className={`${montserratMedium.className} text-gray-cool-700 text-[20px] pb-2`}>{t("bookeeping_balance_sheet")}</p>
                <p className={`${montserratNormal.className} text-gray-cool-500 text-base`}>{t("bookeeping_balance_sheet_desc")}</p>
              </div>
            </div>
            <div className='rounded-lg md:col-start-1 lg:col-start-2 h-full items-center w-full max-w-[380px] border-[1px] pb-6 pl-6 pr-6 overflow-hidden border-gray-cool-200 bg-base-white flex flex-col'>
              <div className="w-full lg:w-[22rem] xl:w-[30rem] h-fit -right-0 lg:-right-2 xl:-right-20 relative overflow-hidden object-contain bg-contain ">
                <Image src={lang == 'en' ? image6_en : image6} />
              </div>
              <div className={`flex flex-col justify-end pt-9`}>
                <p className={`${montserratMedium.className} text-gray-cool-700 text-[20px] pb-2`}>{t("bookeeping_depreciation_report")}</p>
                <p className={`${montserratNormal.className} text-gray-cool-500 text-base`}>{t("bookeeping_depreciation_report_desc")}</p>
              </div>
            </div>

            <div className='grid grid-cols-1 rounded-lg h-full lg:col-start-3 items-center w-fit border-[1px] pb-6 pl-6 pr-6 overflow-hidden border-gray-cool-200 bg-base-white '>
              <div className='w-full h-full'>
                <div className='top-0 w-full lg:w-[21.5rem] xl:w-[23.5rem] lg:-left-4 xl:-left-0 h-fit relative overflow-hidden object-contain bg-contain'>
                  <Image src={image7} className='w-full' />
                </div>
                <div className={`flex flex-col justify-end pt-9 xl:pt-5`}>
                  <p className={`${montserratMedium.className} text-gray-cool-700 text-[20px] pb-2`}>{t("bookeeping_monthly_consultation")}</p>
                  <p className={`${montserratNormal.className} text-gray-cool-500 text-base`}>{t("bookeeping_monthly_consultation_desc")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
